import { render } from "./base-tree.vue?vue&type=template&id=73e080a8&scoped=true&ts=true"
import script from "./base-tree.vue?vue&type=script&lang=ts"
export * from "./base-tree.vue?vue&type=script&lang=ts"

import "./base-tree.vue?vue&type=style&index=0&id=73e080a8&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e080a8"]])

export default __exports__